import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { CompanyService } from "src/app/app/company/company.service";
import { ActivatedRoute } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { HeaderModel } from "src/app/_component/header/header.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ThisPlatform } from "src/app/_services/platform.service";
import { globalHelper } from "src/app/_helpers/global";
import { CompanyGroupService } from "../../company/group/group-service";
import { CompanyGroup, CompanyGroupType } from "../../company/group/gorup.model";
import { UserService } from "src/app/_services";

@Component({
  selector: "app-add-user-department",
  templateUrl: "./add-user-department.page.html",
  styleUrls: [
    "./add-user-department.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class AddUserDepartmentPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    public companyServ: CompanyService,
    public userServ: UserService,
    public companyGroupServ: CompanyGroupService,
    public modalCtrl: ModalController,
    public p: ThisPlatform,
    private el: ElementRef
  ) { }

  @Input()
  userId: number;

  @Input()
  companyId: number;

  headerInit: HeaderModel = {
    title: "DEPARTMENT.DEPARTMENT",
  };

  errorMessage = "";
  form: FormGroup;
  validationError: boolean = false;
  showLoader: boolean;

  companyGroupDepartments: CompanyGroup[] = [];

  ngOnInit() {
    this.showLoader = true;

    this.companyGroupServ.companyGroup = new CompanyGroup();

    this.route.paramMap.subscribe((paramMap) => {
      this.companyGroupServ.getCompanyGroups(this.companyId, CompanyGroupType.Department)
        .subscribe((department: CompanyGroup[]) => {

          this.companyGroupDepartments = department;
          // try {
            this.companyGroupDepartments= department.filter(ar => !this.userServ.userGroupDeparments.find(rm => (rm.id === ar.id)))
          // } catch { }
          this.showLoader = false;
        });
      this.initForm();
    });
  }

  initForm() {
    this.form = new FormGroup({
      department: new FormControl(null, {
        updateOn: "blur",
        validators: [Validators.required],
      }),
    });
  }

  Save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    this.companyGroupServ.postCompanyGroupUser(this.form.value.department.id, 0, this.userId).subscribe(
      (data) => {
        this.close();
      },
      (error) => {
        this.errorMessage = this.onSaveErrorMessage(error.error.code);
      }
    );
  }

  onSaveErrorMessage(code: number) {
    switch (code) {
      case 1:
        return "DEPARTMENT.ERROR_DEPARTMENT_EXISTS";
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }
  onSelectTouched(formControlName: string): void {
    this.form.get(formControlName).markAsTouched();
  }
}
